import { useEffect, useState } from "react";
import { useT } from "@/lib/i18n";

/**
 * Zwevende "naar boven"-knop, linksonder. Verschijnt zodra je een eind naar
 * beneden hebt gescrold (lange pagina's op mobiel). z-30 zodat een sticky
 * koopbalk (z-40) er altijd overheen valt — daar is de knop overbodig.
 * Staat LINKSonder (niet rechts). Aanleiding was de Google Klantenreviews-badge, die rechtsonder
 * met een torenhoge z-index ging zitten; die badge is per 10-08-2026 weg, maar links blijft de
 * betere plek — rechtsonder is waar chat- en cookiewidgets standaard opduiken.
 */
export function ScrollToTop() {
  const t = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = (): void => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label={t("Naar boven")}
      className="fixed bottom-4 left-4 z-30 flex h-11 w-11 items-center justify-center rounded-full border border-primary-200 bg-white/95 text-primary-700 shadow-lg backdrop-blur transition hover:bg-white hover:text-primary-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
    >
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 19V5M6 11l6-6 6 6" />
      </svg>
    </button>
  );
}
